<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button></ion-back-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="goToContactUs()">
        <ion-icon name="information-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{title}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [scrollY]="false">
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <div class="ion-text-center" hidden>
          <p>Version {{appVersion}} Build {{buildVersion}}</p>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" size-lg="4" size-md="6" size-xs="12" offset-lg="4" offset-md="3">
        <form [formGroup]="loginForm" (ngSubmit)="verifyLogin()">
          <ion-item lines="none">
            <ion-label position="stacked" class="auth-button-label">Mobile Number</ion-label>
            <input
              class="auth-input"
              expand="block"
              type="tel"
              formControlName="phone"
              ng2TelInput
              [ng2TelInputOptions]="ng2TelCustomOptions" 
              (hasError)="phoneHasError($event)"
              #phoneNumberInput 
            />
            <p class="form-error" *ngIf="!loginForm.valid">{{ errorMessage }}</p>
          </ion-item>
        </form>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer class="auth-footer">
  <ion-toolbar color="primary">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-button expand="block" [disabled]="!loginForm.valid" (click)="verifyLogin()" class="auth-button primary">Send me a code</ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>